import { render, staticRenderFns } from "./ShareCaseForm.vue?vue&type=template&id=57e5726b&scoped=true&"
import script from "./ShareCaseForm.vue?vue&type=script&lang=js&"
export * from "./ShareCaseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e5726b",
  null
  
)

export default component.exports